import * as logger from '../../../abt-utils/logger'
import * as shared from '../shared'

export function customCriteria (test) {
  return shared.customCriteria(test)
}

export function a (test) {
  shared.markItems('list', 'a')
  return test
}

export function b (test) {
  shared.markItems('list', 'b')
  return System.import('../less/styles.less')
    .catch(logger.error)
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt524/small/index.js
 ** module id = 55
 ** module chunks = 2
 **/